import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Role from './Role';
import AddRoles from './AddRoles';
import EditRole from './EditRole';
import ViewRole from './ViewRole';

const ProtectedRoute = ({ element, permission, fallbackPath = '/dashboard/role' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate(fallbackPath, { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainRole = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.system || {}; // Using 'system' permissions

  return (
    <div className='bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white relative'>
      <Routes>
        <Route path='/' element={<Role />} />

        <Route
          path='/add-role'
          element={<ProtectedRoute element={<AddRoles />} permission={Permission.create} />}
        />

        <Route
          path='/view-role'
          element={<ProtectedRoute element={<ViewRole />} permission={Permission.read} />}
        />

        <Route
          path='/edit-role'
          element={<ProtectedRoute element={<EditRole />} permission={Permission.update} />}
        />
      </Routes>
    </div>
  );
};

export default MainRole;
